import { Button, Modal, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import { useManageScreenTimeFTUXModalStore } from "./ManageScreenTimeFTUXModal"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import { localStorageItems } from "../../util/storage"

interface WelcomeModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useWelcomeModalStore = create<WelcomeModalStore>((set) => ({
  isOpen: false,
  onOpen: () => {
    localStorage.setItem(localStorageItems.needsToSeeWelcomeModal, "true")
    set({ isOpen: true })
  },
  onClose: () => set({ isOpen: false }),
}))

const WelcomeModal = () => {
  const { isOpen, onClose } = useWelcomeModalStore()
  const { onOpen: onOpenManageScreenTimeFTUXModal } =
    useManageScreenTimeFTUXModalStore()
  const { t } = useTranslation()

  const handleNext = () => {
    trackAnalyticEvent(ANALYTIC_EVENTS.FORCE_ONBOARD_INTRO_ALERT)
    onOpenManageScreenTimeFTUXModal()
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      mandatory
      style={{ width: "min(290px, 95vw)" }}
      animate
    >
      <div>
        <img src="/images/squelchee_welcome.png" alt="Welcome to Joonity" />
        <div className="flex flex-col items-center justify-center gap-4 p-6">
          <Typography variant="body" textAlign="center">
            {t("WELCOME_MODAL_BODY")}
          </Typography>
          <Button
            text={t("FTUX_NEXT")}
            onClick={handleNext}
            style={{ width: "80%" }}
          />
        </div>
      </div>
    </Modal>
  )
}

export default WelcomeModal
